module.exports = __webpack_public_path__ + "static/img/Music.d470ef0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutehub/imgs/browse/Music.jpg
// module id = 2318
// module chunks = 0